import React, { forwardRef, useState } from "react";
import {
  FormControl,
  FormHelperText,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { CurrencyRupeeIcon, EmailIcon, LockIcon, VisibilityIcon, VisibilityOffIcon } from "@assets/icons";
import { StyledTextField } from "./CustomInput.styles";

const CustomInput = forwardRef((props, ref) => {
  const {
    type,
    label,
    name,
    error,
    errorMessage,
    helperText,
    size = "small",
    required,
    icon,
    disableIcon = false,
    register,
    inputSXProps,
    inputRef,
    ...otherProps
  } = props;

  const [showPassword, setShowPassword] = useState(false);

  const customLabel = required ? `${label} *` : label;
  const inputType = 
    type === "password" && showPassword ? "text" :
    type === "number" || type === "currency" ? "number" : 
    type || "text";

  const predefinedIcons = {
    currency: <CurrencyRupeeIcon />,
    email: <EmailIcon />,
    password: <LockIcon htmlColor="#9CA3AF" />,
  };

  const inputStartAdornment = disableIcon ? null : icon ||
    (type && predefinedIcons[type]) ? (
    <InputAdornment position="start">
      {icon || predefinedIcons[type]}
    </InputAdornment>
  ) : null;

  const inputEndAdornment = type === "password" ? (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={() => setShowPassword(!showPassword)}
        edge="end"
        size="small"
      >
        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
      </IconButton>
    </InputAdornment>
  ) : null;

  const hasError = error || !!errorMessage;
  const displayHelperText = helperText || errorMessage;
  const actualRef = inputRef || ref;

  return (
    <div className="my-1">
      <FormControl fullWidth error={hasError}>
        <StyledTextField
          id={label}
          name={name}
          type={inputType}
          error={hasError}
          label={customLabel}
          placeholder=""
          size={size}
          fullWidth
          inputRef={actualRef}
          InputProps={{
            sx: {  borderRadius: "8px", ...inputSXProps },
            startAdornment: inputStartAdornment,
            endAdornment: inputEndAdornment,
          }}
          InputLabelProps={{ shrink: true }}
          {...otherProps}
        />
        {displayHelperText && (
          <FormHelperText>{displayHelperText}</FormHelperText>
        )}
      </FormControl>
    </div>
  );
});

CustomInput.displayName = "Input";

export default CustomInput;
